var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_646",
    "data-name": "Raggruppa 646",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "196.4px",
    height: "196.4px",
    viewBox: "0 0 196.4 196.4",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_184",
    width: 196.4,
    height: 196.4,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_645",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_3",
    cx: 90.388,
    cy: 90.388,
    r: 90.388,
    transform: "translate(7.812 7.813)",
    fill: "none",
    stroke: "#ff7373",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_11",
    x1: 82.434,
    y2: 82.434,
    transform: "translate(56.983 56.983)",
    fill: "none",
    stroke: "#ff7373",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_12",
    x2: 82.434,
    y2: 82.434,
    transform: "translate(56.982 56.983)",
    fill: "none",
    stroke: "#ff7373",
    strokeWidth: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutcome);
export default __webpack_public_path__ + "static/media/errorOutcome.cc226c29e74c05920812b006806de026.svg";
export { ForwardRef as ReactComponent };